import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { withRenderFlag } from '@beef/react';
import { cnBem } from '@carnica/utils';
import { selectImgPreviewTypeShow, selectIsImgPreviewOpen } from "../../../../entities/message/model";
import { selectIsFiltersVisible } from "../../../../entities/filters/model";
import { Title } from "../../../../widgets/header/ui/Title";
import styles from "./styles.pcss";
var cnHeaderTitle = cnBem('header-title', styles);
export var HeaderTitle = compose(connect(function (state, ownProps) {
  var isImgPreviewTypeShow = selectImgPreviewTypeShow(state);
  var isImgPreviewOpen = selectIsImgPreviewOpen(state);
  return {
    children: ownProps.children,
    title: isImgPreviewOpen ? 'фото' : 'чат с поддержкой',
    className: "".concat(cnHeaderTitle('', {
      reverse: isImgPreviewTypeShow
    })),
    shouldRender: !selectIsFiltersVisible(state)
  };
}), withRenderFlag)(Title);